<template>
  <div class="wrap" v-loading="loading">
    <iframe
      v-if="link"
      class="all-screen"
      :src="link"
      @load="loaded"
      frameborder="0"
      width="100%"
      height="100%"
      allowfullscreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    ></iframe>

    <div v-if="!isAuth" class="content">
      <img class="no-data" src="@/common/image/no-data.png" />
      <p>该课程无访问权限</p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import Loading from 'element-ui/packages/loading'
import 'element-ui/packages/theme-chalk/src/loading.scss'
Vue.use(Loading.directive)

export default {
  data() {
    return {
      loading: false,
      count: 0, // 鉴权失败，再鉴权一次
      isAuth: true,
      link: ''
    }
  },
  created() {
    this.loading = true
    const token = this.$store.state.token || localStorage.getItem('token')
    const openid = localStorage.getItem('openid')
    // 已有token且openid没改变，不再获取token
    if (token && this.$route.query.openid === openid) {
      this.getPdfUrl()
      return
    }
    this.getToken()
  },
  methods: {
    async getToken() {
      const openid = this.$route.query.openid // 'c74cf9d7-2769-4562-aa31-fd0f7f4fb14f' 测试id
      try {
        const {
          data
        } = await axios.post(
          `${CONFIG.api_backend}/tiger/accounts/oauth/iioe`,
          { openid, pid: 'LHnQoPMr' }
        )
        this.$store.commit('LOGIN', { token: data.token })
        localStorage.setItem('openid', openid)
        this.getPdfUrl()
      } catch (err) {
        this.reset()
      }
    },
    async getPdfUrl() {
      const { package_id, lesson_id, resource_type } = this.$route.query
      const { status, data } = await API.get(`/edu/open/lesson/resource/url`, {
        package_id,
        lesson_id,
        resource_type
      })
      if (status === 200 && data.resource_url) {
        this.link = `static/pdf/web/viewer.html?file=${encodeURIComponent(
          data.resource_url
        )}`
        // this.link = `static/pdf/web/viewer.html?file=${encodeURIComponent('https://public-static-edu.codemao.cn/redboat/courseManage/test.pdf')}` 测试pdf
      } else if (data.error_code === 300008) {
        // 鉴权失败
        ++this.count
        if (this.count > 1) {
          this.reset()
          return
        }
        this.getToken()
      } else {
        this.reset()
      }
    },
    loaded() {
      this.loading = false
    },
    reset() {
      this.loading = false
      this.link = ''
      this.isAuth = false
    }
  }
}
</script>

<style lang="scss">
.wrap {
  .all-screen {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 100;
  }
  .content {
    position: absolute !important;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -55%);
    .no-data {
      display: block;
      margin: auto;
      width: 175px;
    }
    p {
      font-size: 16px;
      color: #666;
      text-align: center;
    }
  }
}
.el-loading-parent--relative {
  position: static !important;
}
</style>
